import React , {useEffect, useState} from 'react';
import {Avatar, Button, Paper, Grid, Typography, Container, TextField, styled } from '@mui/material';
import {FiLock} from 'react-icons/fi';
import Input from './Input';
import styles from './styles';
import { useMemo } from 'react';
import Icon from './Icon';
import { GoogleLogin } from '@react-oauth/google';
import { useDispatch } from 'react-redux';
import jwt_decode from "jwt-decode";
import { useLocation, useNavigate } from 'react-router-dom';
import { googleLogin, login, signup } from '../../actions/auth';
import { Box } from '@mui/system';
import theme from '../../muiTheme';
import * as sanitizer from 'string-sanitizer';

const initialFormState = {
    firstName: '',
    lastName: '',
    email: '',
    password: '',
    confirmPassword: '',
}

const useQuery = () => {

    let location = useLocation();

    return new URLSearchParams(location.search);
}

const Auth = () => {

    const [showPassword, setShowPassword] = useState(false); 
    const [isSignup, setIsSignUp] = useState(false); 
    const [formData, setFormData] = useState(initialFormState);
    const dispatch = useDispatch(); 
    const navigate = useNavigate();
    const query = useQuery(); 
    const [created, setCreated] = useState(false);
    const [error, setError] = useState({
        handle: {
            error: false,
            message: ''
        },
        userName: {
            error: false,
            message: ''
        },
        email: {
            error: false,
            message: ''
        },
        password: {
            error: false,
            message: ''
        },
        unspecified: {
            error: false,
            message: ''
        }
    });

    useEffect(()=>{

        //to set page to signup based on url query
        if(query && query.get('signup')){
            
            console.log('query: ', query.get('signup'));

            setIsSignUp(true);
        }

    }, []);
    
    const handleSubmit = (event) => {

        event.preventDefault(); 
        console.log('formData: ', formData);

        let { validatedFormData, valid }  = sanitizeAndValidate(formData);

        console.log('returned form data: ', validatedFormData);

        if(!valid){

            setFormData(validatedFormData);
            return; 
        }

        if(isSignup){
            //code for if the user is signing up
             
            dispatch( signup(formData, dispatchCallback));

        }else {
            //code for when user is logging in
            dispatch(login(formData, dispatchCallback));

        }

    }

    const dispatchCallback = (err, res) =>{

        if(err){
            console.log('error: ', err);

            let errorType = err.response.data.type; 
            let message = err.response.data.message; 

            let errorObject = {
                handle: {
                    error: false,
                    message: ''
                },
                userName: {
                    error: false,
                    message: ''
                },
                email: {
                    error: false,
                    message: ''
                },
                password: {
                    error: false,
                    message: ''
                },
                unspecified: {
                    error: false,
                    message: ''
                }
            }

            console.log('error type: ', errorType);


            switch(errorType){

                case 'EMAIL_ALREADY_EXISTS':
                    errorObject.email.error = true; 
                    errorObject.email.message = 'An account has already been created with this email address';
                break;

                case 'HANDLE_ALREADY_EXISTS':
                    errorObject.handle.error = true; 
                    errorObject.handle.message = 'This handle is already taken, please choose another one';
                break;

                case 'PASSWORDS_INCONSISTENT': //checked client side, but just incase
                    errorObject.password.error = true; 
                    errorObject.password.message = 'Passwords do not match';
                break; 

                case 'INCORRECT_PASSWORD': //checked client side, but just incase
                    errorObject.unspecified.error = true; 
                    errorObject.unspecified.message = 'The details you provided are incorrect';
                break; 

                case 'INCORRECT_EMAIL': //checked client side, but just incase
                    errorObject.unspecified.error = true; 
                    errorObject.unspecified.message = 'The details you provided are incorrect';
                break; 

                case 'INCORRECT_DETAILS': //checked client side, but just incase
                    errorObject.unspecified.error = true; 
                    errorObject.unspecified.message = 'The details you provided are in an unsupported format, please try again';
                break;

                default:
                    //unspecified error 
                    errorObject.unspecified.error = true; 
                    errorObject.unspecified.message = 'Something went wrong, please try again';
                break;

            }

            setError({
                ...errorObject
            }); 

            return; 
        }

        //do something
        let url = isSignup ? '/profile/edit?stage=0' : '/';
        navigate(url);

    }

    //sanitize and validate form Data
    const sanitizeAndValidate = (formData) => {

        let valid = true; 

        let errorObject = {
            handle: {
                error: false,
                message: ''
            },
            userName: {
                error: false,
                message: ''
            },
            email: {
                error: false,
                message: ''
            },
            password: {
                error: false,
                message: ''
            },
            unspecified: {
                error: false,
                message: ''
            }
        }; 

        for(const property in formData){

            if(property === 'password'){

                let passwordValid = sanitizer.validate.isPassword6to15(formData[property]);

                if(!passwordValid){

                    errorObject.password.error = true; 
                    errorObject.password.message = isSignup ? 'Password is invalid' : 'Password doesn\'t match expected input, please check the format of your password. ';
                    valid = false;
                }

                if(formData[property] !== formData['confirmPassword'] && isSignup){
                    errorObject.password.error = true; 
                    errorObject.password.message = errorObject.password.message.length > 0 ? errorObject.password.message + ' and Passwords do not match' : 'Passwords do not match';
                    valid = false;
                }

                continue; 
            }

            if(property === 'userName'){

                let usernameValid = sanitizer.validate.isUsername(formData[property]);

                if(!usernameValid && isSignup){

                    errorObject.userName.error = true; 
                    errorObject.userName.message = 'Username must be at least 2 characters long, and have no spaces or special characters';
                    valid = false;
                }

                continue; 
            }


            if(property === 'handle'){

                let handleValid = sanitizer.validate.isUsername(formData[property]);

                if(!handleValid){

                    errorObject.handle.error = true; 
                    errorObject.handle.message = 'Handle must be at least 2 characters long, and have no spaces or special characters';
                    valid = false;
                }

                continue; 
            }


            if(property === 'email'){

                let emailValid = sanitizer.validate.isEmail(formData[property]);

                if(!emailValid || formData[property] !== emailValid){

                    errorObject.email.error = true; 
                    errorObject.email.message = 'The email you provided is invalid';
                    valid = false;
                }

                continue; 
            }
            

        }


        setError({
            ...errorObject
        });

        return {
            validatedFormData: formData,
            valid
        }
    }


    const handleChange = (event) => {

        setFormData((prevFormData) =>{
            
            return {
                ...prevFormData, 
                [event.target.name]: event.target.value
            };
        } );
    }

    const handleShowPassword = (value) => {

        setShowPassword((prevShowPassword) => {

            console.log('prev show password: ', prevShowPassword);

            let newValue = typeof value === 'boolean'  ? value : !prevShowPassword; 

            return newValue; 
        
        });
    }

    const switchMode = () => {

        setIsSignUp((prevIsSignup) => !prevIsSignup);
        setShowPassword(false);
    }

    const googleSuccess = async (res) => {
        
        dispatch(googleLogin(res)); 

        navigate('/');
        
    }

    const googleFailure = (error) => {
        console.log('Google sign in was unsuccessful, error: ', error);
    }

    const StyledInput = styled(Input)(({theme}) => ({
        width: '100%',
        marginBottom: '20px',
    }));

    return (

        <Box sx={styles.rootBox}>

        
            <Container component='main' maxWidth='xs' sx={styles.container}>

                <Paper elevation={0} sx={styles.paper}>

                    <Avatar sx={styles.avatar}>
                        <FiLock />
                    </Avatar>

                    <Typography variant="h5" sx={styles.title}>{isSignup ? 'Sign up' : 'Sign In' }</Typography>

                    {isSignup && 

                        <>
                        
                            <Typography variant="body1" sx={{textAlign: 'center', padding: '0px 0px', color: theme.palette.warning.main}}>
                            Please note
                            </Typography>

                            <Typography variant="body2" sx={{ padding: '0px 0px', fontSize: '13px', color: theme.palette.gray}}>
                                This product is still in its early stages of development. New users need to be verified before they can post content. Some essential features such as account recovery are still in development. <b>Please refrain from providing or posting sensitive information.</b>
                            </Typography>
                        </>
                        
                    }

                    <form onSubmit={handleSubmit} style={styles.form}>

                        <Box container='true' spacing={2} sx={styles.formBox}>

                            {isSignup && 
                                <>
                                    <Input name="handle" label="Pick a Handle" error={error.handle.error} handleChange={handleChange} style={styles.formItem} autoFocus/>
                                    { error.handle.error &&
                                        <Typography variant="body1" sx={{alignSelf: 'baseline', fontSize: '13px', padding: '0px 0px', marginBottom: '5px', color: theme.palette.error.main}}>
                                            {error.handle.message}
                                        </Typography>
                                    }


                                    <Input name="userName" label="Pick a Username" error={error.userName.error} placeholder='@handle' handleChange={handleChange} style={styles.formItem} />
                                    { error.userName.error &&
                                        <Typography variant="body1" sx={{alignSelf: 'baseline', fontSize: '13px', padding: '0px 0px', marginBottom: '5px', color: theme.palette.error.main}}>
                                            {error.userName.message}
                                        </Typography>
                                    }
                                    
                                </>
                            }

                            <Input name='email' label='Email' error={error.email.error} handleChange={handleChange} type='email'/>
                            { error.email.error &&
                                <Typography variant="body1" sx={{alignSelf: 'baseline', fontSize: '13px', padding: '0px 0px', marginBottom: '5px', color: theme.palette.error.main}}>
                                    {error.email.message}
                                </Typography>
                            }


                            {
                                isSignup &&

                                <Typography variant="body1" sx={{ fontSize: '13px', padding: '10px 0px', color: error.password.error ? theme.palette.error.main : theme.palette.gray}}>
                                    Password must be 6 to 15 characters, with at least one numeric digit and one special character.
                                </Typography>
                            }
                            

                            <Input name='password' error={error.password.error} label='Password' handleChange={handleChange} type={showPassword ? 'text' : 'password'} handleShowPassword={handleShowPassword}/>
                            { error.password.error &&
                                <Typography variant="body1" sx={{alignSelf: 'baseline', fontSize: '13px', padding: '0px 0px', marginBottom: '5px', color: theme.palette.error.main}}>
                                    {error.password.message}
                                </Typography>
                            }

                            { isSignup && 
                                <Input name='confirmPassword'  label='Confirm Password' handleChange={handleChange} type={showPassword ? 'text' : 'password'} handleShowPassword={handleShowPassword}/>
                            }

                        </Box>


                        
                        <Typography variant="body1" sx={{ fontSize: '13px', padding: '10px 0px', color: theme.palette.gray}}>
                            By signing {isSignup ? 'up': 'in'}, you are confirming that you agree to our terms and conditions (WIP), as well as our privacy policy (WIP). 
                        </Typography>

                        <Button type='submit' fullWidth variant='main' color='primary' sx={styles.submit} >
                            {isSignup ? 'Sign Up ' : 'Sign In'}
                        </Button>

                        {/* <div sx={styles.googleButton}>
                            <GoogleLogin 
                                onSuccess={googleSuccess}
                                onFailure = {googleFailure}
                                
                            />
                        </div> */}
                        

                        { error.unspecified.error &&
                            <Typography variant="body1" sx={{alignSelf: 'baseline', fontSize: '13px', padding: '0px 0px', marginBottom: '5px', color: theme.palette.error.main}}>
                                {error.unspecified.message}
                            </Typography>
                        }

                        <Button onClick={switchMode} sx={{marginTop: '20px', textTransform: 'none'}}>

                            {isSignup ? 'Already have an account? Sign In' : 'New here? Sign Up!'}
                        </Button>

                            

                    </form>
                </Paper>
            </Container>

        </Box>
    );
}

export default Auth;